import React, { useContext } from "react";
import { GlobalContext } from "components/AppProvider";
import { AppProviderTypes } from "components/AppProvider/AppProvider.props";
import { ReactComponent as CloseIcon } from "assets/icons/Closeclose.svg";
import "./_styles.css";

const Notification: React.FunctionComponent = () => {
    const [states, setStates] = useContext(GlobalContext);

    return (
        <div className="ticker">
            <div className="ticker-list">{states.notificationMessage}</div>
            <CloseIcon
                className="close-icon"
                onClick={() =>
                    setStates((prv: AppProviderTypes) => ({
                        ...prv,
                        showNotification: false,
                    }))
                }
            />
        </div>
    );
};

export default Notification;
